import useSWR from 'swr';
import { DeepNullable } from 'ts-essentials';

import fetcher from 'lib/fetcher';
import { APIApartmentRoomType } from 'api/types';
import { ApartmentFilters } from './use-aparments-filter-query';
import { IPolygonItemRequest } from './use-apartments-limits-secondary';

export type PlansItemType = {
  areaInSqM: number;
  id: number;
  media: { id: number; mimeType: string; name: string; url: string | null };
  selected: boolean | null;
};

export type APIApartmentFilterLimitsRes = {
  count: number;
  filters: DeepNullable<{
    areaMax: number;
    areaMin: number;
    priceMax: number;
    priceMin: number;
    pricePerSqMMax: number;
    pricePerSqMMin: number;
    marketPriceMax: number;
    marketPriceMin: number;
    secondaryMarketPriceDifferenceMax: number;
    secondaryMarketPriceDifferenceMin: number;
    plans: PlansItemType[];
    polygons: IPolygonItemRequest[];
  }> & { facilityTypes: APIApartmentRoomType[] };
};

const useApartmentsSecondaryFilterLimits = (filter?: ApartmentFilters | null, fetch = true) => {
  const { data, error, isLoading, isValidating } = useSWR(fetch ? [filter] : null, ([filter]) =>
    fetcher
      .swr<APIApartmentFilterLimitsRes>('/facilities/filter-limits', {
        method: 'post',
        data: { filter: { ...filter, marketType: 'Secondary' } },
      })
      .then((res) => {
        return res;
      }),
  );


  return {
    filterLimits: data?.filters,
    count: data?.count,
    error,
    isLoading: isLoading || isValidating,
  };
};

export default useApartmentsSecondaryFilterLimits;
